import { Box } from '@chakra-ui/react'

const Divider = ({ bg = 'black', height = '2px' }) => {
  return <Box bg={bg} width={'full'} height={height}></Box>
}

export default Divider
